<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
      <a-form-item label="抬头名称">
        <a-input v-model="dataForm.company_name" placeholder="请输入抬头名称" allowClear />
      </a-form-item>
      <a-form-item label="发票类型">
        <a-select v-model="dataForm.type" placeholder="请选择" style="width: 120px" allowClear>
          <a-select-option value="1">普通发票</a-select-option>
          <a-select-option value="2">专用发票</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="开票状态">
        <a-select v-model="dataForm.invoice_type" placeholder="请选择" style="width: 120px" allowClear>
          <a-select-option value="1">待开票</a-select-option>
          <a-select-option value="2">已开票</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="业务类型">
        <a-select v-model="dataForm.business_type" placeholder="请选择" style="width: 120px" allowClear @change="onBusinessTypeChange">
          <a-select-option value="1">行程</a-select-option>
          <a-select-option value="2">会费</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="客户">
        <a-select
          v-model="dataForm.customer_id"
          placeholder="请输入客户姓名搜索"
          style="width: 200px"
          allowClear
          show-search
          :filter-option="false"
          :not-found-content="customerFetching ? undefined : null"
          @search="handleCustomerSearch"
          @focus="getCustomerList"
          @change="onCustomerChange"
        >
          <a-spin v-if="customerFetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in customerList" :key="item.customer_id" :value="item.customer_id">
            {{ item.customer_name }} - {{ item.customer_phone }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- <a-form-item label="行程" v-if="!dataForm.business_type || dataForm.business_type === '1'">
        <a-select
          v-model="dataForm.trip_id"
          :placeholder="dataForm.customer_id ? '请输入行程名称搜索' : '请先选择客户'"
          style="width: 200px"
          allowClear
          show-search
          :disabled="!dataForm.customer_id"
          :filter-option="false"
          :not-found-content="tripFetching ? undefined : null"
          @search="handleTripSearch"
          @focus="getTripList"
        >
          <a-spin v-if="tripFetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in tripList" :key="item.trip_id" :value="item.trip_id">
            {{ item.trip_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会员缴费" v-if="dataForm.business_type === '2'">
        <a-select
          v-model="dataForm.member_id"
          :placeholder="dataForm.customer_id ? '请选择会员缴费期数' : '请先选择客户'"
          style="width: 200px"
          allowClear
          show-search
          :disabled="!dataForm.customer_id"
          :filter-option="false"
          :not-found-content="memberFetching ? undefined : null"
          @search="handleMemberSearch"
          @focus="getMemberList"
        >
          <a-spin v-if="memberFetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in memberList" :key="item.member_id" :value="item.member_id">
            {{ item.vip_key }} - ¥{{ item.pay_price }}
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label="创建时间">
        <a-range-picker
          v-model="dateRange"
          @change="onChangeTime"
          allowClear
          value-format="YYYY-MM-DD"
          style="width: 240px"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item v-permission="['admin:invoice:create']">
        <a-button type="primary" @click="addOrUpdateHandle()">新增发票</a-button>
      </a-form-item>
    </a-form>

    <a-table
      :columns="columns"
      :data-source="dataList"
      :pagination="false"
      rowKey="uid"
      :loading="dataListLoading"
      :scroll="{ x: 2100 }"
    >
      <template slot="type" slot-scope="type">
        <a-tag :color="type === '1' ? 'blue' : 'green'">
          {{ type === '1' ? '普通发票' : '专用发票' }}
        </a-tag>
      </template>
      <template slot="invoice_type" slot-scope="invoice_type">
        <a-tag :color="invoice_type === '1' ? 'orange' : 'green'">
          {{ invoice_type === '1' ? '待开票' : '已开票' }}
        </a-tag>
      </template>
      <template slot="business_type" slot-scope="business_type">
        <a-tag :color="business_type === '1' ? 'purple' : 'orange'">
          {{ business_type === '1' ? '行程' : business_type === '2' ? '会费' : '未设置' }}
        </a-tag>
      </template>
      <template slot="customerinfo" slot-scope="customerinfo">
        <div v-if="customerinfo">
          <div>{{ customerinfo.customer_name }}</div>
          <div style="color: #999; font-size: 12px">{{ customerinfo.customer_phone }}</div>
        </div>
        <a-tag v-else color="red">未关联</a-tag>
      </template>
      <template slot="relationinfo" slot-scope="text, row">
        <div v-if="row.business_type === '1'">
          <!-- 业务类型为行程时，显示行程信息 -->
          <div v-if="row.tripinfo">
            <a-icon type="car" style="color: #1890ff" />
            {{ row.tripinfo.trip_name }}
          </div>
          <a-tag v-else color="red">未关联行程</a-tag>
        </div>
        <div v-else-if="row.business_type === '2'">
          <!-- 业务类型为会费时，显示会员缴费信息 -->
          <div v-if="row.memberinfo">
            <a-icon type="credit-card" style="color: #52c41a" />
            {{ row.memberinfo.vip_key }} - ¥{{ row.memberinfo.pay_price }}
          </div>
          <a-tag v-else color="red">未关联会费</a-tag>
        </div>
        <a-tag v-else color="orange">未设置业务类型</a-tag>
      </template>
      <template slot="filesChildren" slot-scope="filesChildren">
        <div v-if="filesChildren && filesChildren.length > 0">
          <a-tag color="green">{{ filesChildren.length }} 个文件</a-tag>
        </div>
        <a-tag v-else color="orange">暂无文件</a-tag>
      </template>
      <template slot="company_name" slot-scope="text, row">
        <div>
          <div style="font-weight: bold">{{ text }}</div>
          <div v-if="row.tin" style="color: #999; font-size: 12px">税号: {{ row.tin }}</div>
        </div>
      </template>
      <template slot="action" slot-scope="text, row">
        <a-button
          type="link"
          @click="addOrUpdateHandle(row.uid)"
          v-permission="['admin:invoice:update']"
        >
          编辑
        </a-button>
        <a-button
          type="link"
          @click="viewEmailLog(row)"
          v-permission="['admin:invoice:emaillog']"
        >
          <a-icon type="mail" /> 邮件日志
        </a-button>
        <a-button
          type="link"
          style="color: red"
          @click="deleteHandle(row.uid)"
          v-permission="['admin:invoice:delete']"
        >
          删除
        </a-button>
      </template>
    </a-table>

    <a-pagination
      class="mr-20 float-right"
      show-size-changer
      :current="page"
      :total="total"
      :show-total="(total) => `共 ${total} 条数据`"
      @showSizeChange="showSizeChange"
      @change="pageCurrentChangeHandle"
    />

    <!-- 新增/编辑弹窗 -->
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>

    <!-- 邮件日志弹窗 -->
    <a-modal
      title="邮件发送日志"
      :visible="emailLogVisible"
      @cancel="emailLogVisible = false"
      :footer="null"
      width="800px"
      destroyOnClose
    >
      <div v-if="currentEmailLog" style="max-height: 500px; overflow-y: auto">
        <a-alert
          message="发票信息"
          type="info"
          show-icon
          style="margin-bottom: 16px"
        >
          <template slot="description">
            <div><strong>抬头名称：</strong>{{ currentInvoiceInfo.company_name }}</div>
            <div><strong>收票邮箱：</strong>{{ currentInvoiceInfo.email || '未填写' }}</div>
          </template>
        </a-alert>
        <div style="background: #f5f5f5; padding: 16px; border-radius: 4px; white-space: pre-wrap; word-wrap: break-word; font-family: 'Courier New', monospace; font-size: 12px; line-height: 1.6">
          {{ currentEmailLog }}
        </div>
      </div>
      <a-empty v-else description="暂无邮件发送记录" />
    </a-modal>

    <!-- 详情弹窗 -->
    <a-modal
      title="发票详情"
      :visible="detailVisible"
      @cancel="detailVisible = false"
      :footer="null"
      width="900px"
      destroyOnClose
    >
      <a-descriptions bordered :column="2" v-if="detailInfo">
        <a-descriptions-item label="发票类型">
          <a-tag :color="detailInfo.type === '1' ? 'blue' : 'green'">
            {{ detailInfo.type === '1' ? '普通发票' : '专用发票' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="业务类型">
          <a-tag :color="detailInfo.business_type === '1' ? 'purple' : 'orange'">
            {{ detailInfo.business_type === '1' ? '行程' : detailInfo.business_type === '2' ? '会费' : '未设置' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="开票金额">
          {{ detailInfo.money ? `¥${detailInfo.money}` : '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="开票状态">
          <a-tag :color="detailInfo.invoice_type === '1' ? 'orange' : 'green'">
            {{ detailInfo.invoice_type === '1' ? '待开票' : '已开票' }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="抬头名称">
          {{ detailInfo.company_name }}
        </a-descriptions-item>
        <a-descriptions-item label="税号">
          {{ detailInfo.tin || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="注册地址">
          {{ detailInfo.registered_ddress || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="注册电话">
          {{ detailInfo.registration_phone || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="银行名称">
          {{ detailInfo.bank_name || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="银行账号">
          {{ detailInfo.bank_account || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="邮箱">
          {{ detailInfo.email || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="关联客户" :span="2">
          <div v-if="detailInfo.customerinfo">
            {{ detailInfo.customerinfo.customer_name }} - {{ detailInfo.customerinfo.customer_phone }}
          </div>
          <span v-else>未关联</span>
        </a-descriptions-item>
        <a-descriptions-item v-if="detailInfo.business_type === '1'" label="关联行程" :span="2">
          <div v-if="detailInfo.tripinfo">
            <a-icon type="car" style="color: #1890ff" />
            {{ detailInfo.tripinfo.trip_name }}
          </div>
          <span v-else>未关联行程</span>
        </a-descriptions-item>
        <a-descriptions-item v-if="detailInfo.business_type === '2'" label="关联会费缴费" :span="2">
          <div v-if="detailInfo.memberinfo">
            <a-icon type="credit-card" style="color: #52c41a" />
            {{ detailInfo.memberinfo.vip_key }} - ¥{{ detailInfo.memberinfo.pay_price }}
          </div>
          <span v-else>未关联会费</span>
        </a-descriptions-item>
        <a-descriptions-item label="创建时间" :span="2">
          {{ detailInfo.create_time }}
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">
          {{ detailInfo.remark || '未填写' }}
        </a-descriptions-item>
        <a-descriptions-item label="邮件发送日志" :span="2">
          <div v-if="detailInfo.sendemail_log" style="white-space: pre-wrap; word-break: break-word; max-height: 200px; overflow-y: auto; padding: 8px; background: #f5f5f5; border-radius: 4px; font-size: 12px">
            {{ detailInfo.sendemail_log }}
          </div>
          <span v-else style="color: #999">无发送记录</span>
        </a-descriptions-item>
        <a-descriptions-item label="发票文件" :span="2">
          <div v-if="detailInfo.filesChildren && detailInfo.filesChildren.length > 0">
            <div
              v-for="file in detailInfo.filesChildren"
              :key="file.id"
              style="margin-bottom: 8px"
            >
              <a :href="file.file" target="_blank" style="margin-right: 10px">
                <a-icon type="file-pdf" /> 查看文件 {{ file.id }}
              </a>
            </div>
          </div>
          <span v-else style="color: #999">暂无文件</span>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";

export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    if (this.customerSearchTimer) {
      clearTimeout(this.customerSearchTimer);
    }
    if (this.tripSearchTimer) {
      clearTimeout(this.tripSearchTimer);
    }
    if (this.memberSearchTimer) {
      clearTimeout(this.memberSearchTimer);
    }
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/invoice/page",
        deleteURL: "/admin/invoice/delete",
      },
      dataForm: {
        company_name: "",
        type: undefined,
        invoice_type: undefined,
        business_type: undefined,
        customer_id: undefined,
        trip_id: undefined,
        member_id: undefined,
        start_time: "",
        end_time: "",
      },
      dateRange: [],
      customerList: [],
      customerFetching: false,
      customerSearchTimer: null,
      tripList: [],
      tripFetching: false,
      tripSearchTimer: null,
      memberList: [],
      memberFetching: false,
      memberSearchTimer: null,
      detailVisible: false,
      detailInfo: null,
      emailLogVisible: false,
      currentEmailLog: '',
      currentInvoiceInfo: {},
      columns: [
      {
          title: "客户信息",
          dataIndex: "customerinfo",
          scopedSlots: { customRender: "customerinfo" },
          width: 200,
          fixed: "left",
        },
        {
          title: "抬头名称",
          dataIndex: "company_name",
          scopedSlots: { customRender: "company_name" },
          width: 180,
        },

        {
          title: "发票类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
          width: 120,
        },
        {
          title: "开票金额",
          dataIndex: "money",
          width: 120,
          customRender: (text) => text ? `¥${text}` : '-',
        },
        {
          title: "开票状态",
          dataIndex: "invoice_type",
          scopedSlots: { customRender: "invoice_type" },
          width: 100,
        },
        {
          title: "业务类型",
          dataIndex: "business_type",
          scopedSlots: { customRender: "business_type" },
          width: 100,
        },
        {
          title: "关联信息",
          dataIndex: "relationinfo",
          scopedSlots: { customRender: "relationinfo" },
          width: 220,
        },
        {
          title: "注册地址",
          dataIndex: "registered_ddress",
          width: 200,
          ellipsis: true,
        },
        {
          title: "银行名称",
          dataIndex: "bank_name",
          width: 150,
        },
        {
          title: "收票邮箱",
          dataIndex: "email",
          width: 180,
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 200,
          ellipsis: true,
        },
        {
          title: "发票文件",
          dataIndex: "filesChildren",
          scopedSlots: { customRender: "filesChildren" },
          width: 120,
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180,
        },
        {
          title: "操作",
          scopedSlots: { customRender: "action" },
          width: 280,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    // 查看邮件日志
    viewEmailLog(row) {
      this.currentEmailLog = row.sendemail_log || '';
      this.currentInvoiceInfo = {
        company_name: row.company_name,
        email: row.email,
      };
      this.emailLogVisible = true;
    },
    onChangeTime(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.dataForm.start_time = `${dateStrings[0]} 00:00:00`;
        this.dataForm.end_time = `${dateStrings[1]} 23:59:59`;
      } else {
        this.dataForm.start_time = "";
        this.dataForm.end_time = "";
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 客户搜索（带防抖）
    handleCustomerSearch(value) {
      // 清除之前的定时器
      if (this.customerSearchTimer) {
        clearTimeout(this.customerSearchTimer);
      }
      
      // 设置新的定时器，500ms 后执行搜索
      this.customerSearchTimer = setTimeout(() => {
        this.getCustomerList(value);
      }, 500);
    },
    // 获取客户列表
    getCustomerList(searchKeyword = '') {
      // 如果没有搜索关键词且列表已有数据，则不重复请求
      if (!searchKeyword && this.customerList.length > 0) return;
      
      this.customerFetching = true;
      this.$http({
        url: "/admin/customer/allCustomerSelect",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_name: searchKeyword, // 模糊搜索客户姓名
        },
      }).then((res) => {
        this.customerList = res.data.result || [];
      }).finally(() => {
        this.customerFetching = false;
      });
    },
    // 业务类型改变时的处理
    onBusinessTypeChange(value) {
      // 清空行程和会员缴费选择
      this.dataForm.trip_id = undefined;
      this.dataForm.member_id = undefined;
      // 清空列表
      this.tripList = [];
      this.memberList = [];
    },
    // 客户改变时，清空行程选择和列表，并自动加载行程或会员缴费
    onCustomerChange(value) {
      // 清空行程选择
      this.dataForm.trip_id = undefined;
      // 清空行程列表
      this.tripList = [];
      // 清空会员缴费选择
      this.dataForm.member_id = undefined;
      // 清空会员列表
      this.memberList = [];
      // 如果选择了客户，根据业务类型自动加载相应列表
      if (value) {
        if (!this.dataForm.business_type || this.dataForm.business_type === '1') {
          this.getTripList();
        } else if (this.dataForm.business_type === '2') {
          this.getMemberList();
        }
      }
    },
    // 行程搜索（带防抖）
    handleTripSearch(value) {
      // 清除之前的定时器
      if (this.tripSearchTimer) {
        clearTimeout(this.tripSearchTimer);
      }
      
      // 设置新的定时器，500ms 后执行搜索
      this.tripSearchTimer = setTimeout(() => {
        this.getTripList(value);
      }, 500);
    },
    // 获取行程列表（需要先选择客户）
    getTripList(searchKeyword = '') {
      // 如果没有选择客户，不执行查询
      if (!this.dataForm.customer_id) {
        this.$message.warning('请先选择客户');
        return;
      }
      
      // 如果没有搜索关键词且列表已有数据，则不重复请求
      if (!searchKeyword && this.tripList.length > 0) return;
      
      this.tripFetching = true;
      this.$http({
        url: "/admin/trip/page",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_id: this.dataForm.customer_id, // 根据客户ID筛选
          trip_name: searchKeyword, // 模糊搜索行程名称
        },
      }).then((res) => {
        this.tripList = res.data.result || [];
      }).finally(() => {
        this.tripFetching = false;
      });
    },
    // 会员缴费搜索（带防抖）
    handleMemberSearch(value) {
      // 清除之前的定时器
      if (this.memberSearchTimer) {
        clearTimeout(this.memberSearchTimer);
      }
      
      // 设置新的定时器，500ms 后执行搜索
      this.memberSearchTimer = setTimeout(() => {
        this.getMemberList(value);
      }, 500);
    },
    // 获取会员缴费列表（需要先选择客户）
    getMemberList(searchKeyword = '') {
      // 如果没有选择客户，不执行查询
      if (!this.dataForm.customer_id) {
        this.$message.warning('请先选择客户');
        return;
      }
      
      // 如果没有搜索关键词且列表已有数据，则不重复请求
      if (!searchKeyword && this.memberList.length > 0) return;
      
      this.memberFetching = true;
      this.$http({
        url: "/admin/member/page",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_id: this.dataForm.customer_id, // 根据客户ID筛选
          vip_key: searchKeyword, // 模糊搜索会员期数
        },
      }).then((res) => {
        this.memberList = res.data.result || [];
      }).finally(() => {
        this.memberFetching = false;
      });
    },
    // 查看详情
    viewDetail(row) {
      this.$http({
        url: "/admin/invoice/info",
        method: "get",
        params: {
          id: row.uid,
        },
      }).then((res) => {
        this.detailInfo = res.data;
        this.detailVisible = true;
      });
    },
  },
};
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>

